import { render, staticRenderFns } from "./EleccionesView.vue?vue&type=template&id=b9f65a90&"
import script from "./EleccionesView.vue?vue&type=script&lang=ts&"
export * from "./EleccionesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports